export default "__VITE_ASSET__02049e7a__"